import { WordArtRenderProps } from '../../type/common.interface';
import { callMainRender } from './call-main-render';
import { callWorkerRender } from './call-worker-render';

export function callRender(props: WordArtRenderProps, options: { useWorker?: boolean }) {
    if (options.useWorker) {
        callWorkerRender(props);
    } else {
        callMainRender(props);
    }
}
